// OOTB Code
'use strict';

const { queryFirst, addClass, queryAll, removeClass, remove, scrollTo } = require('../domUtil');
const { formatPhoneNumber } = require('../util');
const { contactUsTemplate } = require('../templates');
const { HIDDEN_CLASS } = require('../constants');

const shippingPhoneNumberEl = queryFirst('.contact-us-phone .form-control');
const contactUsSubmit = queryFirst('.subscribe-contact-us');
const tulipDisabledClass = 'tulip-disabled';
const appointmentDisabledClass = 'appointment-disabled';
const textUnderlineClass = 'tulip-text-underline';
const ERROR_TIMEOUT_LENGTH = 3000;

/**
 * Hides the visible subgroup of Contact Us topics
 */
function hideSelectedSubgroup() {
    const subGroup = queryFirst('.sub-group.show');
    removeClass(subGroup, 'show');
}

/**
 * Handles hiding/showing Contact Us subgroups when the user clicks the radio
 * button for certain topics.
*/
function radioHideShow() {
    const contactRadio = $('form.contact-us input[type=radio][name=contactTopic]');
    contactRadio.on('change', (e) => {
        const { value } = e.target;
        const radioGroup = queryFirst('form.contact-us .radio-group');
        removeClass(radioGroup, 'invalid-group'); // Clears out any error messaging
        hideSelectedSubgroup();
        const subgroup = queryFirst(`.${value}-group`);
        if (subgroup) {
            addClass(subgroup, 'show');
        }
    });
}

/**
 * Deselects the subtopic radio button
 */
function deselectSubtopic() {
    queryAll('input[name="subTopic"]').forEach((e) => { e.checked = false; });
}

/**
 * Clears out any text in the other reason field
*/
function clearOtherReasonField() {
    queryFirst('#contact-reason-other-reason').value = '';
}

/**
 * Deselects the subtopic radio buttons when user focuses on the "Other Reason" form field
 */
function otherFieldFocus() {
    $('#contact-reason-other-reason').on('focus', function () {
        deselectSubtopic();
    });
}
/**
 * Clears out the other reason field when the user selects a subtopic
 */
function subtopicFocus() {
    $('input[name="subTopic"]').on('click', function () {
        clearOtherReasonField();
    });
}

/**
 * Clears out the general form error above the submit button
 */
function clearFormError() {
    const formError = queryFirst('.form-error-container .custom-error-alert');
    remove(formError);
}

/**
 * Displays a general form error above the submit button using a message returned from the contactUsSubmitHttpService response
 * @param {string} message - Error message to display to the user
 */
function displayFormError(message) {
    const errorHtml = message ? contactUsTemplate.signupError(message) : contactUsTemplate.defaultSignupError;
    const errorContainer = queryFirst('.form-error-container');
    errorContainer.innerHTML = errorHtml;

    setTimeout(() => {
        contactUsSubmit.removeAttribute('disabled');
        clearFormError();
    }, ERROR_TIMEOUT_LENGTH);
}

/**
 * Adds an invalid class to the radio form group if the inputs are invalid.
 */
function invalidRadioHandler() {
    $(this).parents('.radio-group').addClass('invalid-group');
}

module.exports = {
    init: function () {
        const enableTulip = queryFirst('.js-tulip-enabled');
        const tulipStylistAvailable = queryFirst('.tulip-stylist-available');
        const tulipStylistDisabled = queryFirst('.tulip-stylist-disabled');
        const tulipAppointmentAvailable = queryFirst('.tulip-appointment-available');
        const tulipAppointmentDisabled = queryFirst('.tulip-appointment-disabled');
        const chatContainer = queryFirst('.chat-container');
        const appointmentContainer = queryFirst('.appointment-container');
        const chatIcon = queryFirst('.chat-icon', chatContainer);
        const calendarIcon = queryFirst('.chat-icon', appointmentContainer);
        const chatIconDisabled = queryFirst('.chat-icon-disabled', chatContainer);
        const calendarIconDisabled = queryFirst('.chat-icon-disabled', appointmentContainer);
        const tulipChatText = queryFirst('.tulip-chat-text');
        const stylistAndAppointmentAvailable = tulipStylistAvailable && tulipAppointmentAvailable;
        const stylistAndAppointmentDisabled = tulipStylistDisabled && tulipAppointmentDisabled;
        const stylistBlock = queryFirst('.stylist-block');
        const isLoggedIn = queryFirst('.is-loggedin');
        const signInContainer = queryFirst('.sign-in-box');
        const signInLink = queryFirst('.sign-in-page');
        const myAccountLink = queryFirst('.myaccount-page');
        const findStoreContainer = queryFirst('.find-store');
        const findStoreLink = queryFirst('.find-store-link');
        if (enableTulip) {
            if (stylistAndAppointmentDisabled) {
                addClass([tulipStylistDisabled, tulipAppointmentDisabled], HIDDEN_CLASS);
                removeClass(chatContainer, tulipDisabledClass);
                removeClass(appointmentContainer, appointmentDisabledClass);
            }
            if (stylistAndAppointmentAvailable) {
                removeClass([tulipStylistAvailable, tulipAppointmentAvailable], HIDDEN_CLASS);
                removeClass(chatContainer, tulipDisabledClass);
                removeClass(appointmentContainer, appointmentDisabledClass);
            }
        } else {
            if (stylistAndAppointmentAvailable) {
                addClass([tulipStylistAvailable, tulipAppointmentAvailable, chatIcon, calendarIcon], HIDDEN_CLASS);
                addClass(chatContainer, tulipDisabledClass);
                addClass(appointmentContainer, appointmentDisabledClass);
                removeClass([chatIconDisabled, calendarIconDisabled], HIDDEN_CLASS);
                removeClass(tulipChatText, textUnderlineClass);
            }
            addClass(stylistBlock, HIDDEN_CLASS);
            if (stylistAndAppointmentDisabled) {
                removeClass([tulipStylistDisabled, tulipAppointmentDisabled, chatIconDisabled, calendarIconDisabled], HIDDEN_CLASS);
                addClass(chatContainer, tulipDisabledClass);
                addClass(appointmentContainer, appointmentDisabledClass);
                addClass([chatIcon, calendarIcon], HIDDEN_CLASS);
                removeClass(tulipChatText, textUnderlineClass);
            }
        }
        if (signInLink && myAccountLink) {
            if (isLoggedIn && isLoggedIn.value === 'true') {
                addClass(signInLink, HIDDEN_CLASS);
                removeClass(myAccountLink, HIDDEN_CLASS);
                signInContainer.setAttribute('onclick', `location.href='${myAccountLink.href}'`);
            } else {
                addClass(myAccountLink, HIDDEN_CLASS);
                removeClass(signInLink, HIDDEN_CLASS);
                signInContainer.setAttribute('onclick', `location.href='${signInLink.href}'`);
            }
        }
        if (findStoreLink && findStoreContainer) {
            findStoreContainer.setAttribute('onclick', `location.href='${findStoreLink.href}'`);
        }
    },
    radioHideShow: radioHideShow,
    otherFieldFocus: otherFieldFocus,
    subtopicFocus: subtopicFocus,
    contactReasonError: function () {
        $('form.contact-us input[type=radio][name=contactTopic]').on('invalid', invalidRadioHandler);
    },
    subscribeContact: () => {
        const $form = $('form.contact-us');
        $form.submit((e) => {
            e.preventDefault();
            const url = $form.attr('action');
            $.spinner().start();
            clearFormError();
            contactUsSubmit.setAttribute('disabled', true);
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: data => {
                    $.spinner().stop();
                    if (data.success) {
                        $('.contact-us').trigger('reset');
                        const contactUsLanding = queryFirst('.contact-us-landing-page');
                        const contactUsForm = queryFirst('form.contact-us', contactUsLanding);
                        const contactUsSuccess = queryFirst('.contact-us-success', contactUsLanding);
                        addClass(contactUsForm, HIDDEN_CLASS);
                        removeClass(contactUsSuccess, HIDDEN_CLASS);
                        const headerHeight = queryFirst('header.main-header').offsetHeight;
                        scrollTo($('.contactus-header').offset().top - headerHeight);
                    } else {
                        displayFormError(data.msg);
                    }
                },
                error: () => {
                    $.spinner().stop();
                    displayFormError();
                }
            });
        });
    },
    formatPhoneNumberOnChange: function () {
        if (shippingPhoneNumberEl) {
            formatPhoneNumber(shippingPhoneNumberEl);
        }
    }
};
